import React from "react";
import { connect } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const mapStateToProps = (state) => ({
    config: state.configReducer
});

const RequireCompaniesAccess = ({ config }) => {
    const hasAccess = config.menu.some((x) => x && x.context === "companies");
    return hasAccess ? <Outlet /> : <Navigate to="/home" replace />;
};

export default connect(mapStateToProps, {})(RequireCompaniesAccess);
